/**
 * Insights API helpers
 * @module lib/insights/query
 */

const { buildInsightsActiveUrl, resolveInsightsArticleId } = require('./urls');

async function fetchActiveEmbedItem(articleId, options = {}) {
  const resolvedId = resolveInsightsArticleId(articleId);
  const url = buildInsightsActiveUrl(resolvedId, options);
  if (!url) return null;

  try {
    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data || data.success === false || !data.active) return null;
    return {
      type: data.type || null,
      payload: data.payload || data.survey || data.contest || null
    };
  } catch (_) {
    return null;
  }
}

module.exports = {
  fetchActiveEmbedItem
};
